import { GetCulpritCustomerAttachedDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedDocumentImages/getCulpritCustomerAttachedDocumentImagesQuery.type';
import { getCulpritCustomerAttachedDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedDocumentImages/getCulpritCustomerAttachedDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCustomerAttachedDocumentImagesQueryOptions = (
  params: GetCulpritCustomerAttachedDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['CulpritCustomerAttachedDocumentImages', params],
    queryFn: () => getCulpritCustomerAttachedDocumentImagesFunction(params),
    enabled: true,
  });
};
